/**
 * Error message of a request error.
 *
 * @param {string} spec.member - ????
 * @param {string} spec.message - Error message
 */
class ErrorMessage extends Object {
	constructor(spec) {
		super(spec);

		this._member = spec.member;
		this._message = spec.message;
	}

	toString() {
		let str = "";
		if (this._member !== undefined) {
			str += `${this._member} - `;
		}
		if (this._message !== undefined) {
			str += this._message;
		}

		return str;
	}
}

/**
 * Error returned when a request failed.
 *
 * @param {{}} spec.jqXHR - jQuery ajax response
 */
export default class ErrorResult extends Object {
	constructor(spec) {
		super(spec);

		this._errors = [];

		// Init
		if (spec.jqXHR) {
			let jsonData;
			try {
				jsonData = JSON.parse(spec.jqXHR.responseText);
			} catch {
				this._errors = [spec.jqXHR.responseText || "Unknown error"];
				jsonData = null;
			}

			// Array of errors
			if (jsonData && jsonData.errors) {
				this._errors = jsonData.errors.map(
					(errorData) => new ErrorMessage(errorData),
				);
			}

			// Single error
			if (jsonData && jsonData.message) {
				this._errors = [new ErrorMessage(jsonData)];
			}
		}
	}

	toString() {
		return this._errors.map((error) => error.toString()).join("\n");
	}
}
